<template>
  <div class="home-container">
    <!-- 导航 -->
    <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
 
    <!-- 头部背景 -->
    <div class="top_bg">
        <div class="container_box">
            <div style="font-size: 50px;">让天下没有难做的生意</div>
            <div style="font-size: 20px;margin-top: 20px;font-size: 20px;">坚持为小企业服务,因为小企业是中国梦想最多的地方</div>
          </div>
    </div>
    <!-- 行程安排 -->
    <div style="width: 1200px;margin: 0 auto;">
      <div style="display: flex;align-items: center;margin-top: 54px;">
        <div>
            <div class="title">ZHAOMEIW</div>
            <div class="title2">行程安排</div>
        </div>
        <div class="float_line"></div>
      </div>
      <div style="display: flex;justify-content: space-between;margin-top: 83px;">
        <div class="plan_box">
          <div class="plan_img">
            <img src="../../static/img/school/1.png" alt="" style="width: 100%;height: 100%;">
            <div class="titles">1.西溪园区</div>
          </div>
          <div class="plan_container">
            <div class="plan_title">走进西溪园区</div>
            <div class="plan_detail">
              访客中心是园区把5号楼独立布置且转为客户而来！聚焦了阿里巴巴文化发展：阿里土话、武侠文化、淘宝亲文化；倒立文化，135年陈文化，天猫无人超市等的运营亮点分享于一体的多功能文化交流中心——是客户“亲”在园区温暖的家
            </div>
          </div>
        </div>
        <div class="plan_box">
          <div class="plan_img">
            <img src="../../static/img/school/2.png" alt="" style="width: 100%;height: 100%;">
            <div class="titles">2.太极禅苑</div>
          </div>
          <div class="plan_container">
            <div class="plan_title">太极禅苑</div>
            <div class="plan_detail">
              太极禅苑是阿里巴巴文化中心之一：传承中国传统文化和传播阿里巴巴文化的场馆，在这里参悟“文化是玩出来”的阿里文化精髓：感受传统太极哲学的魅力！
            </div>
          </div>
        </div>
        <div class="plan_box">
          <div class="plan_img">
            <img src="../../static/img/school/3.png" alt="" style="width: 100%;height: 100%;">
            <div class="titles">3.专题讲座</div>
          </div>
          <div class="plan_container">
            <div class="plan_title">阿里巴巴文化</div>
            <div class="plan_detail">
              1.透彻了阿里巴巴文化发展之旅、2.阿里六脉神剑是如何实施落地，价值又是如何进行绩效管理、3.阿里人的阿里味道成长故事！4.现场文化工坊切实教你如何提炼属于自己公司的文化
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 主题环境 -->
    <div class="theme">
      <div style="width: 1200px;margin: 0 auto;">
        <div style="display: flex;align-items: center;padding-top: 38px;">
          <div>
              <div class="title" style="color: #fff;">ZHAOMEIW</div>
              <div class="title2" style="color: #fff;">主题环境</div>
          </div>
          <div class="float_line"></div>
        </div>
        <div style="display: flex;margin-top: 23px;justify-content: space-between;">
          <div class="border_box" >
            <div class="dot" style="margin-top: 80px;"></div>
            <div class="long"></div>
            <div class="border_box2">
              <div class="padding_box">
                <div class="padding_img"><img src="../../static/img/school/p1.png" alt="" style="width: 100%;height: 100%;"></div>
                <div class="padding_title">走进西溪园区</div>
                <div class="padding_title2">感受阿里独特的文化体系魅力</div>
                <div class="padding_title3">
                  <div class="padding_title4">西溪园区</div>
                </div>
              </div>
            </div>
          </div>
          <div class="border_box" >
            <div class="border_box2">
              <div class="padding_box">
                <div class="padding_img"><img src="../../static/img/school/p2.png" alt="" style="width: 100%;height: 100%;"></div>
                <div class="padding_title">聆听专题讲座</div>
                <div class="padding_title2">阿里高管现场分享管理的经验</div>
                <div class="padding_title3">
                  <div class="padding_title4">主题讲座</div>
                </div>
              </div>
            </div>
            <div class="long"></div>
            <div class="dot"></div>
          </div>
          <div class="border_box" >
            <div class="dot" style="margin-top: 80px;"></div>
            <div class="long"></div>
            <div class="border_box2">
              <div class="padding_box">
                <div class="padding_img"><img src="../../static/img/school/p3.png" alt="" style="width: 100%;height: 100%;"></div>
                <div class="padding_title">分享合作方案</div>
                <div class="padding_title2">王董现场讲解，合作共赢</div>
                <div class="padding_title3">
                  <div class="padding_title4">合作场景</div>
                </div>
              </div>
            </div>
          </div>
          <div class="border_box" >
            <div class="border_box2">
              <div class="padding_box">
                <div class="padding_img"><img src="../../static/img/school/p4.png" alt="" style="width: 100%;height: 100%;"></div>
                <div class="padding_title">开启授牌仪式</div>
                <div class="padding_title2">找美网牵手阿里，正式授牌</div>
                <div class="padding_title3">
                  <div class="padding_title4">授牌仪式</div>
                </div>
              </div>
            </div>
            <div class="long"></div>
            <div class="dot"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 精彩瞬间 -->
    <div style="width: 1200px;margin: 0 auto;margin-bottom: 58px;">
      <div style="display: flex;align-items: center;margin-top: 77px;">
        <div>
            <div class="title">ZHAOMEIW</div>
            <div class="title2">精彩瞬间</div>
        </div>
        <div class="float_line"></div>
      </div>
      <div class="moment_box">
        <div class="moment">
          <div class="moment_img"><img src="../../static/img/school/moment.png" alt=""></div>
          <div class="bottom_box">
            <div class="picture"><img src="../../static/img/school/01.png" alt=""></div>
            <div class="namelist">
              <div class="temp1">舞动乾坤</div>
              <div class="temp2">Dance the world</div>
            </div>
            <!-- <div class="temp3">
              <div class="temp3_1">时尚</div>
            </div> -->
           </div>
        </div>
        <div class="moment">
          <div class="moment_img"><img src="../../static/img/school/moment1.png" alt=""></div>
          <div class="bottom_box">
            <div class="picture"><img src="../../static/img/school/02.png" alt=""></div>
            <div class="namelist">
              <div class="temp1">拍照留念</div>
              <div class="temp2">Taking Photos</div>
            </div>
            <!-- <div class="temp3">
              <div class="temp3_1">时尚</div>
            </div> -->
          </div>
        </div>
        <div class="moment">
          <div class="moment_img"><img src="../../static/img/school/moment2.png" alt=""></div>
          <div class="bottom_box">
            <div class="picture"><img src="../../static/img/school/03.png" alt=""></div>
            <div class="namelist">
              <div class="temp1">感受阿里文化</div>
              <div class="temp2">Experience Alibaba's culture</div>
            </div>
            <!-- <div class="temp3">
              <div class="temp3_1">时尚</div>
            </div> -->
          </div>
        </div>
        <div class="moment">
          <div class="moment_img"><img src="../../static/img/school/moment3.png" alt=""></div>
          <div class="bottom_box">
            <div class="picture"><img src="../../static/img/school/04.png" alt=""></div>
            <div class="namelist">
              <div class="temp1">现场解说</div>
              <div class="temp2">Live commentary</div>
            </div>
            <!-- <div class="temp3">
              <div class="temp3_1">时尚</div>
            </div> -->
          </div>
        </div>
        <div class="moment" style="margin-top: 63px;">
          <div class="moment_img"><img src="../../static/img/school/moment7.png" alt=""></div>
          <div class="bottom_box">
            <div class="picture"><img src="../../static/img/school/05.png" alt=""></div>
            <div class="namelist">
              <div class="temp1">体验产品</div>
              <div class="temp2">Experience products</div>
            </div>
            <!-- <div class="temp3">
              <div class="temp3_1">时尚</div>
            </div> -->
          </div>
        </div>
        <div class="moment" style="margin-top: 63px;">
          <div class="moment_img"><img src="../../static/img/school/moment5.png" alt=""></div>
          <div class="bottom_box">
            <div class="picture"><img src="../../static/img/school/06.png" alt=""></div>
            <div class="namelist">
              <div class="temp1">阿里攻守道</div>
              <div class="temp2">Offensive and defensive ways</div>
            </div>
            <!-- <div class="temp3">
              <div class="temp3_1">时尚</div>
            </div> -->
          </div>
        </div>
        <div class="moment" style="margin-top: 63px;">
          <div class="moment_img"><img src="../../static/img/school/moment4.png" alt=""></div>
          <div class="bottom_box">
            <div class="picture"><img src="../../static/img/school/07.png" alt=""></div>
            <div class="namelist">
              <div class="temp1">参观园区</div>
              <div class="temp2">Visit the park</div>
            </div>
            <!-- <div class="temp3">
              <div class="temp3_1">时尚</div>
            </div> -->
          </div>
        </div>
        <div class="moment" style="margin-top: 63px;">
          <div class="moment_img"><img src="../../static/img/school/moment6.png" alt=""></div>
          <div class="bottom_box">
            <div class="picture"><img src="../../static/img/school/08.png" alt=""></div>
            <div class="namelist">
              <div class="temp1">毕业照</div>
              <div class="temp2">Graduation photo</div>
            </div>
            <!-- <div class="temp3">
              <div class="temp3_1">时尚</div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <RMBottomDiv></RMBottomDiv>
  </div>
</template>

<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue'
  import { mapGetters } from "vuex";
  import { mapMutations } from "vuex";
  import * as types from "../store/mutation-types";
  export default {
    components: {RMTopDiv,RMBottomDiv},
    data() {
      return {
        scroll: '',
        scroll100: true,
        scroll700: false
      };
    },
    watch: {
      scroll: function () {      
        this.loadSroll();
      }
    },
    methods: {
      //首页
      goToHome() {
        this.$router.push('/')
      },
      //产品中心-店务系统介绍
      goToDw() {
        this.$router.push('./home')
      },
      //产品中心-供应链
      goToSupply() {
        this.$router.push('./supplyChain')
      },
      //产品中心-营销工具
      goToMark() {
        this.$router.push('./marketingTools')
      },
      //关于我们-公司简介
      goToUS() {
        this.$router.push('./company')
      },
      //关于我们-合作渠道
      goToChannel() {
        this.$router.push('./channels')
      },
      //关于我们-招聘
      goToContact() {
        this.$router.push('./contact')
      },
      //关于我们-企业文化
      goToCulture() {
        this.$router.push('./culture')
      },
      //找美商学院-商学院文化
      goToCollege(){
        this.$router.push("./school");
      },
      //找美商学院-走进阿里
      goToAli(){
        this.$router.push("./Ali");
      },
       //找美商学院-行程安排
      gotoTravell(){
          this.$router.push('./Travell')
      },
       //找美商学院-讲师简介
      goToTeach(){},
       //找美商学院-相关案例
      goToCase(){},
      apply() {

      },
      dataScroll(event) {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
      },
      loadSroll: function () {
        if (this.scroll <= 100) {
          this.scroll100 = true
        } else {
          this.scroll100 = false
        }
        if (this.scroll > 100) {
          this.scroll700 = true
        } else {
          this.scroll700 = false
        }
      },
    },
    created() {

    },

    computed: {
      ...mapGetters(["username", "password", "treeData", "stafftype", "limit"])

    },
    mounted() {
      //获取高度
      window.addEventListener("scroll", this.dataScroll, true);
    }
  };
</script>

<style scoped lang="scss">
  @import "../assets/css/them.scss";
  @import "../assets/css/mains.css";

  .home-container {
    background-color: #fff;
    width: 100%;
    height: 100%;
    position: fixed;
    overflow-y: scroll;
  }

  .top_bg {
    background-image: url('../../static/img/school/banner.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 824px;
    position: relative;
    top: 0;
    left: 0;
  }

  .container_box {
    z-index: 1;
    position: absolute;
    top: 30%;
    left: 0;
    color: #fff;
    text-align: center;
    min-width: 769px;
    width: 100%;
  }
  .title{
        font-size: 36px;
        color: #343434;
    }
    .title2{
        font-size: 26px;
        color: #343434;
        margin-top: 11px;
    }
    .float_line{
        background: #D8E1E0;
        width:694px;
        height:2px;
    }
    .plan_box{
      width: 387px;
      height: 522px;
      position: relative;
    }
    .plan_img{
      width: 333px;
      height: 522px;
      margin-left: 23px;
      position: relative;
    }
    .titles{
      font-size: 30px;
      color: white;
      position: absolute;
      top: 27px;
      left: 89px;
    }
    .plan_container{
      background: white;
      width: 387px;
      height: 290px;
      position: absolute;
      top: 90px;
    }
    .plan_title{
      font-size: 22px;
      margin-left: 65px;
      text-align: center;
      margin-top: 51px;
      color: #000;
      width: 249px;
    }
    .plan_detail{
      font-size: 14px;
      color: #000;
      width: 312px;
      line-height: 26px;
      margin:27px 38px 52px 37px;
    }
    .plan_container:hover{
      background: #ED7829;
      color: #fff;
    }
    .plan_container:hover .plan_title{
      border:1px solid rgba(255,255,255,1);
      color: #fff;
      padding: 5px;
    }
    .plan_container:hover .plan_detail{
      color: white;
    }
    .theme{
      background-image: url('../../static/img/school/4.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      width: 100%;
      height: 744px;
      margin-top: 90px;
    }
    .border_box{
      width: 287px;
      height: 528px;
    }
    .dot{
      width: 31px;
      height: 31px;
      background: white;
      border-radius: 50%;
      margin-left: 129px;
    }
    .long{
      width: 1px;
      height: 131px;
      margin-left:144px;
      background: white;
    }
    .border_box2{
      width:286px;
      height:286px;
      border:1px solid rgba(255,255,255,1);
    }
    .padding_box{
      margin: 31px 29px 26px 26px;
      width: 232px;
      height: 232px;
      background: white;
    }
    .padding_img{
      width: 232px;
      height: 93px;
      background: orchid;
    }
    .padding_title{
      text-align: center;
      margin-top: 12px;
      color: #ED7829;
      font-size: 20px;
      font-weight: 500;
    }
    .padding_title2{
      text-align: center;
      margin-top: 3px;
      color: #565656;
      font-size: 12px;
    }
    .padding_title3{
      width:94px;
      height:21px;
      background:rgba(255,255,255,1);
      border-radius:11px;
      border:1px solid rgba(237,120,41,1);
      margin-left: 71px;
      margin-top: 23px;
    }
    .padding_title4{
      font-size: 12px;
      color: #ED7829;
      font-weight: 500;
      line-height: 17px;
      text-align: center;
      padding: 2px;
    }
    .moment_box{
      display: flex;
      margin-top: 17px;
    
      height: 647px;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .moment{
      /* background: rebeccapurple; */
      width: 277px;
      height: 292px;
    }
    .moment_img{
      width: 277px;
      height: 198px;
    }
    .moment_img img{
      width: 100%;
      height: 100%;
    }
    .bottom_box{
      display: flex;
      align-items: center;
      background-image: url('../../static/img/school/pink.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      width: 277px;
      height: 94px;
    }
    .picture{
      width: 50px;
      height: 50px;
      margin-left: 10px;
    }
    .picture img{
      width: 100%;
      height: 100%;
    }
    .namelist{
      margin-top: 0px;
      margin-left: 15px;
      width: 250px;
      /* background: orange; */
    }
    .temp1{
      font-size: 16px;
      color: #353535;
    }
    .temp2{
      font-size: 12px;
      color: #353535;
      margin-top: 0px;
      line-height: 20px;
    }
    .temp3{
      width:60px ;
      height: 30px;
      border: 1px solid #333;
      line-height: 30px;
      border-radius: 6px;
    }
    .temp3_1{
      font-size: 16px;
      text-align: center;
      color: #353535;
    }
</style>


// WEBPACK FOOTER //
// src/page/Travell.vue